import React, { useState } from 'react';
import { Search, MapPin, AlertCircle } from 'lucide-react';
interface SiteListProps {
  onSelectSite: (siteId: string) => void;
}
const MOCK_SITES = [{
  id: 'CH-001',
  name: 'Pont Rivière-Nord',
  city: 'Montréal',
  status: 'En cours',
  progress: 65
}, {
  id: 'CH-014',
  name: 'Égout Laval',
  city: 'Laval',
  status: 'En cours',
  progress: 42
}, {
  id: 'CH-022',
  name: 'Réfection Rue King',
  city: 'Sherbrooke',
  status: 'À risque',
  progress: 28
}, {
  id: 'CH-035',
  name: 'Viaduc Highway 40',
  city: 'Montréal',
  status: 'En cours',
  progress: 81
}];
export function SiteList({
  onSelectSite
}: SiteListProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredSites = MOCK_SITES.filter(site => site.name.toLowerCase().includes(searchQuery.toLowerCase()) || site.id.toLowerCase().includes(searchQuery.toLowerCase()) || site.city.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="p-4 space-y-4" data-id="element-159">
      {/* Search Bar */}
      <div className="relative" data-id="element-160">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-161" />
        <input type="text" placeholder="Rechercher un chantier..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-162" />
      </div>
      {/* Site Cards */}
      <div className="space-y-3" data-id="element-163">
        {filteredSites.map(site => <button key={site.id} onClick={() => onSelectSite(site.id)} className="w-full bg-white rounded-lg border border-gray-200 p-4 text-left hover:shadow-md transition-shadow" data-id="element-164">
            <div className="flex items-start justify-between mb-2" data-id="element-165">
              <div className="flex-1" data-id="element-166">
                <h3 className="font-semibold text-gray-900 text-lg mb-1" data-id="element-167">
                  {site.name}
                </h3>
                <p className="text-sm text-gray-600 font-mono" data-id="element-168">{site.id}</p>
              </div>
              {site.status === 'À risque' && <span className="flex items-center text-red-600 text-xs font-medium bg-red-50 px-2 py-1 rounded" data-id="element-169">
                  <AlertCircle size={14} className="mr-1" data-id="element-170" />À risque
                </span>}
              {site.status === 'En cours' && <span className="text-green-600 text-xs font-medium bg-green-50 px-2 py-1 rounded" data-id="element-171">
                  En cours
                </span>}
            </div>
            <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-172">
              <MapPin size={16} className="mr-1" data-id="element-173" />
              <span data-id="element-174">{site.city}</span>
            </div>
            {/* Progress Bar */}
            <div className="space-y-1" data-id="element-175">
              <div className="flex justify-between text-xs text-gray-600" data-id="element-176">
                <span data-id="element-177">Avancement</span>
                <span className="font-medium" data-id="element-178">{site.progress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-179">
                <div className="bg-red-600 h-2 rounded-full transition-all" style={{
              width: `${site.progress}%`
            }} data-id="element-180" />
              </div>
            </div>
          </button>)}
      </div>
      {filteredSites.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-181">
          <p data-id="element-182">Aucun chantier trouvé</p>
        </div>}
    </div>;
}